export default __webpack_public_path__ + "static/media/tonnage.aac13218.svg";